(function (w, d) {
	if (w.location.pathname !== '/chargeback-protection.html') return;

	const config = {
		sectionOffset: 300,
		throttleTime: 200,
		throttleSpeed: 25,
	}
	const animation = throttle(updateScroll, config.throttleTime);

	initAnimation();

	function updateScroll() {
		const sectionAboutVmpi = d.querySelector('.js-about-vmpi');
		const sectionCallToActionAbout = d.querySelector('.js-call-to-action-about');
		const sectionStepsVmpi = d.querySelector('.js-steps-vmpi');
		const sectionAboutPrice = d.querySelector('.js-about-price');
		const sectionFeedback = d.querySelector('.js-feedback');
		const position = w.scrollY + config.sectionOffset;

		if (w.innerWidth > 960) {
			if (isSectionChanged(position, sectionAboutVmpi, sectionCallToActionAbout)) {
				animate(sectionAboutVmpi);
			} else if (isSectionChanged(position, sectionCallToActionAbout, sectionStepsVmpi)) {
				animate(sectionCallToActionAbout);
			} else if (isSectionChanged(position, sectionStepsVmpi, sectionAboutPrice)) {
				animate(sectionStepsVmpi);
			} else if (isSectionChanged(position, sectionAboutPrice, sectionFeedback)) {
				animate(sectionAboutPrice);
			}
		}
	}

	function isSectionChanged(scroll, start, end) {
		if (end !== undefined) {
			return scroll > start.offsetTop && scroll < end.offsetTop;
		}
		return scroll > start.offsetTop;
	}

	function animate(section) {
		const sectionCallToActionAbout = d.querySelector('.js-call-to-action-about');
		const title = section.querySelector('.js-text-fill');
		const activeElements = section.querySelectorAll('.js-translate');
		const sectionHeight = w.scrollY - section.offsetTop;

		if (title) {
			title.classList.add(`${section === sectionCallToActionAbout ? 'title-fill_inverted' : 'title-fill'}`);
		}
		activeElements.forEach(element => {
			element.style.transform = `translateY(${Math.round(sectionHeight / config.throttleSpeed)}px)`
		});
	}

	function initAnimation() {
		const activeElements = d.querySelectorAll('.js-translate');

		activeElements.forEach(element => {
			element.style.transform = `translateY(-11px)`;
		});
		w.addEventListener('scroll', animation);
	}
})(window, document);
